var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWhatsapp2300124(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.337%",
    y1: "20.953%",
    x2: "87.686%",
    y2: "77.588%",
    id: "3sl7h2521b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AD068",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45B629",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "229e92a9gg"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-.5%",
    y: "4.5%",
    width: "99.1%",
    height: "99.4%",
    filterUnits: "objectBoundingBox",
    id: "691dxk0o7a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-31.6%",
    y: "-25.2%",
    width: "163.2%",
    height: "163%",
    filterUnits: "objectBoundingBox",
    id: "dgdbhi1p5e"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.066 7.87c0 1.387.362 2.74 1.05 3.934L0 15.882l4.173-1.094a7.868 7.868 0 0 0 3.762.958h.004c4.339 0 7.87-3.53 7.872-7.87.001-2.103-.817-4.08-2.303-5.568A7.823 7.823 0 0 0 7.938 0C3.6 0 .069 3.53.067 7.87zm2.485 3.729-.155-.248a6.524 6.524 0 0 1-1-3.48A6.552 6.552 0 0 1 7.94 1.328c1.748.001 3.39.682 4.626 1.919a6.502 6.502 0 0 1 1.915 4.627 6.552 6.552 0 0 1-6.543 6.542h-.003a6.535 6.535 0 0 1-3.33-.912l-.24-.142-2.476.65.661-2.414z",
    id: "29fg22au7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.066 7.87c0 1.387.362 2.74 1.05 3.934L0 15.882l4.173-1.094a7.868 7.868 0 0 0 3.762.958h.004c4.339 0 7.87-3.53 7.872-7.87.001-2.103-.817-4.08-2.303-5.568A7.823 7.823 0 0 0 7.938 0C3.6 0 .069 3.53.067 7.87zm2.485 3.729-.155-.248a6.524 6.524 0 0 1-1-3.48A6.552 6.552 0 0 1 7.94 1.328c1.748.001 3.39.682 4.626 1.919a6.502 6.502 0 0 1 1.915 4.627 6.552 6.552 0 0 1-6.543 6.542h-.003a6.535 6.535 0 0 1-3.33-.912l-.24-.142-2.476.65.661-2.414z",
    id: "tj83nzvanf"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#691dxk0o7a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.908 17.78 1.117-4.078a7.856 7.856 0 0 1-1.05-3.934c0-4.34 3.532-7.87 7.872-7.87 2.106.001 4.082.82 5.569 2.308a7.822 7.822 0 0 1 2.304 5.568c-.002 4.34-3.534 7.87-7.873 7.87h-.003a7.868 7.868 0 0 1-3.762-.958L1.908 17.78z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.337 7.872c0 1.339.35 2.646 1.015 3.798L.274 15.608l4.029-1.057c1.11.605 2.36.924 3.631.925h.004c4.188 0 7.598-3.409 7.6-7.598a7.55 7.55 0 0 0-2.224-5.375A7.552 7.552 0 0 0 7.937.275C3.748.275.34 3.683.337 7.872",
    fill: "url(#3sl7h2521b)",
    transform: "translate(1.908 1.898)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.908 1.898)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3bsex7a49d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#29fg22au7c"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#3bsex7a49d)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#dgdbhi1p5e)",
    xlinkHref: "#tj83nzvanf"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#229e92a9gg)",
    xlinkHref: "#tj83nzvanf"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M7.88 6.478c-.148-.328-.303-.334-.443-.34-.115-.005-.246-.005-.377-.005a.723.723 0 0 0-.525.246c-.18.197-.688.673-.688 1.64 0 .969.705 1.904.803 2.035.098.132 1.36 2.181 3.36 2.97 1.662.655 2 .524 2.36.492.361-.033 1.164-.476 1.328-.935.164-.46.164-.853.115-.936-.05-.082-.18-.13-.377-.23-.197-.098-1.164-.574-1.344-.64-.18-.065-.312-.097-.443.1-.131.196-.508.64-.623.77-.114.132-.229.148-.426.05-.196-.099-.83-.306-1.582-.976a5.925 5.925 0 0 1-1.094-1.363c-.115-.196-.012-.303.086-.401.089-.088.197-.23.296-.345.098-.114.13-.196.196-.327.066-.132.033-.247-.016-.345-.05-.098-.432-1.071-.607-1.46",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp2300124);
export default __webpack_public_path__ + "static/media/icon-whatsapp_2_30_01_24.0997e13cae25bce6bac3c2f448b42461.svg";
export { ForwardRef as ReactComponent };